import usePrivateAxios from "@/common/api/usePrivateAxios";
import { useQuery } from "@tanstack/react-query";
import { MissionProvider } from "../types/missionProvider.type";

type UseMissionProvidersProps<T> = {
  mapper?: (data: MissionProvider[]) => T;
};

export const useMissionProviders = <T = MissionProvider[]>({
  mapper,
}: UseMissionProvidersProps<T> = {}) => {
  const privateAxios = usePrivateAxios();
  const mapResult: (data: MissionProvider[]) => T =
    mapper ??
    ((providers: MissionProvider[]) =>
      providers as unknown as T);

  return useQuery<T, Error, T, ["missionsProviders"]>({
    queryKey: ["missionsProviders"],
    queryFn: async () => {
      const response = await privateAxios.get(
        "/tmais/mission_requirements/available_providers",
      );

      const candidates = [
        response.data?.data,
        response.data?.available_providers,
        response.data?.data?.available_providers,
        response.data,
      ];
      const payload =
        candidates.find((candidate) => Array.isArray(candidate)) ?? [];
      return mapResult(payload as MissionProvider[]);
    },
  });
};
